export const DESKTOP_WIDTH = 1170; // px
export const TABLET_WIDTH = 970; // px
export const MOBILE_WIDTH = 750; // px
